module.exports = __webpack_public_path__ + "static/media/mw.a097ecc5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mw.svg
// module id = 2166
// module chunks = 0